// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"391d147f","842":"d0d881ac","932":"d6bbd7d5"}[chunkId] + ".chunk.js";
};